"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalAppSwitcher_component_exports = {};
__export(GlobalAppSwitcher_component_exports, {
  GlobalAppSwitcher: () => GlobalAppSwitcher,
  default: () => GlobalAppSwitcher_component_default
});
module.exports = __toCommonJS(GlobalAppSwitcher_component_exports);
var import_react = __toESM(require("react"));
var import_keyBy = __toESM(require("lodash/keyBy"));
var import_GlobalAppSwitcher = require("./GlobalAppSwitcher.styled");
var import_GlobalHeader = require("../GlobalHeader/GlobalHeader.constants");
var import_Button = require("../../atoms/Button/Button.component");
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_atoms = require("../../atoms");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Helpers = require("../../../utils/Helpers");
var import_react_i18next = require("react-i18next");
var import_molecules = require("../../molecules");
var import_Tooltip = require("../../atoms/Tooltip/Tooltip.component");
var import_GlobalHeader2 = require("../contexts/GlobalHeader/GlobalHeader.controller");
var import_GlobalAppSwitcher2 = require("./GlobalAppSwitcher.enum");
var import_i18n = __toESM(require("../../../i18n"));
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
var GlobalAppSwitcher = function GlobalAppSwitcher2(_ref) {
  var _ref$productsList = _ref.productsList, productsList = _ref$productsList === void 0 ? (0, import_GlobalAppSwitcher2.getAppsKey)() : _ref$productsList, ariaLabel = _ref.ariaLabel, buttonTitle = _ref.buttonTitle, className = _ref.className, _ref$isAppsOpened = _ref.isAppsOpened, isAppsOpened = _ref$isAppsOpened === void 0 ? false : _ref$isAppsOpened, _ref$color = _ref.color, color = _ref$color === void 0 ? "#407177" : _ref$color, currentPlatform = _ref.currentPlatform, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, customPositionOfPopover = _ref.customPositionOfPopover, _ref$withKebabMenu = _ref.withKebabMenu, withKebabMenu = _ref$withKebabMenu === void 0 ? true : _ref$withKebabMenu;
  var isReadOnly = productsList ? productsList.includes("readonly") : false;
  var globalHeaderPopupStateConsumer = (0, import_GlobalHeader2.useGlobalHeaderPopupState)();
  var appSwitcherMobileRef = (0, import_react.useRef)(null);
  var appSwitcherMobileButtonRef = (0, import_react.useRef)(null);
  var appSwitcherMobileGoBackButtonRef = (0, import_react.useRef)(null);
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var is400percent = breakpoints.isSm;
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var apps = [];
  var filteredProducts = [];
  var _useState = (0, import_react.useState)(false), _useState2 = _slicedToArray(_useState, 2), appSwitcherModalState = _useState2[0], setAppSwitcherModalState = _useState2[1];
  var _useState3 = (0, import_react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), appSwitcherMobileState = _useState4[0], setAppSwitcherMobileState = _useState4[1];
  if (isReadOnly) {
    apps = [(0, import_GlobalAppSwitcher2.getAppFrom)(import_GlobalAppSwitcher2.AppsList.gm.key)];
  } else {
    var _filteredProducts;
    filteredProducts = _toConsumableArray(productsList);
    var containsEquip = (_filteredProducts = filteredProducts) === null || _filteredProducts === void 0 ? void 0 : _filteredProducts.includes("equip");
    if (containsEquip) {
      filteredProducts.unshift(import_GlobalAppSwitcher2.AppsList.insync.key);
      filteredProducts.unshift(import_GlobalAppSwitcher2.AppsList.affirm.key);
    }
    apps = Array.from(
      new Set(
        // remove duplicates
        filteredProducts.map(
          function(id) {
            return (0, import_GlobalAppSwitcher2.getAppFrom)(id);
          }
          // map received licences to the corresponding app
        ).filter(function(app) {
          return app !== void 0;
        }).filter(function(_ref2) {
          var key = _ref2.key;
          return key !== currentPlatform;
        })
      )
      // and filter current platform
    );
    apps.push(import_GlobalAppSwitcher2.AppsList.gm);
    if (currentPlatform === "in-sync" || currentPlatform === "affirm" || currentPlatform === "geodesdig") {
      apps.push(import_GlobalAppSwitcher2.AppsList.um);
    }
  }
  var onSelectApp = function onSelectApp2(appId) {
    var selectedApp = apps.find(function(app) {
      return app.key === appId;
    });
    window.open(selectedApp.url, "_blank");
    return true;
  };
  (0, import_react.useEffect)(function() {
    setTimeout(function() {
      if (appSwitcherMobileState) {
        appSwitcherMobileRef.current.focus();
      }
    }, 0);
  }, [appSwitcherMobileState]);
  var setFocusOnAppSwitcherIcon = function setFocusOnAppSwitcherIcon2() {
    setTimeout(function() {
      appSwitcherMobileButtonRef.current.focus();
    }, 100);
  };
  (0, import_useOnKeydown.useOnKeydown)(appSwitcherMobileRef, function(keylist, event) {
    var Escape = keylist.Escape, ArrowDown = keylist.ArrowDown, ArrowUp = keylist.ArrowUp;
    var appSwitcherButtons = appSwitcherMobileRef.current.querySelectorAll("button[id]");
    var buttonsId = Object.keys((0, import_keyBy.default)(appSwitcherButtons, "id"));
    var activeItem = document.activeElement;
    var currentPosition = buttonsId.indexOf(activeItem.id);
    var appsListSize = appSwitcherButtons.length - 1;
    event.stopPropagation();
    if (Escape) {
      setAppSwitcherMobileState(false);
      setFocusOnAppSwitcherIcon();
    }
    if (ArrowDown) {
      var pos = [appsListSize, -1].includes(currentPosition) ? 0 : currentPosition + 1;
      if (appSwitcherButtons[pos]) {
        appSwitcherButtons[pos].focus();
      }
    }
    if (ArrowUp) {
      var _pos = currentPosition <= 0 ? appsListSize : currentPosition - 1;
      if (appSwitcherButtons[_pos]) {
        appSwitcherButtons[_pos].focus();
      }
    }
  });
  (0, import_react.useEffect)(function() {
    if (appSwitcherMobileState) {
      (0, import_Helpers.trapFocus)(appSwitcherMobileRef.current);
    }
  }, [appSwitcherMobileState]);
  var handleOnEnterPress = function handleOnEnterPress2(event) {
    if (event.key === "Enter") {
      setAppSwitcherMobileState(false);
      setFocusOnAppSwitcherIcon();
    }
  };
  if (globalHeaderPopupStateConsumer) {
    (0, import_react.useEffect)(function() {
      if (appSwitcherModalState) {
        globalHeaderPopupStateConsumer.setGlobalHeaderActivePopup(import_GlobalHeader.popupsIds.globalAppSwitcherPopup);
      }
    }, [appSwitcherModalState]);
    (0, import_react.useEffect)(function() {
      if (globalHeaderPopupStateConsumer.globalHeaderActivePopup !== import_GlobalHeader.popupsIds.globalAppSwitcherPopup) {
        setAppSwitcherModalState(false);
      }
    }, [globalHeaderPopupStateConsumer.globalHeaderActivePopup]);
  }
  var activator = function activator2(_ref3) {
    var listOpened = _ref3.listOpened, toggleList = _ref3.toggleList, activatorRef = _ref3.activatorRef;
    return /* @__PURE__ */ import_react.default.createElement(import_Tooltip.Tooltip, {
      value: buttonTitle || t("dp_core_globalAppSwitcher_greatMindsAppSwitcher"),
      placement: "bottom",
      offset: [25, 5]
    }, /* @__PURE__ */ import_react.default.createElement(import_Button.Button, {
      icon: "apps",
      onClick: toggleList,
      ref: activatorRef,
      darkMode,
      "aria-expanded": listOpened,
      variant: "empty",
      circle: true,
      size: "40px",
      iconSize: 26,
      className: "teacher-app-switcher",
      ariaLabel: ariaLabel || t("dp_core_globalAppSwitcher_greatMindsAppSwitcher"),
      "data-testid": "app-switcher-activator"
    }));
  };
  var items = apps.map(function(app) {
    var key = app.key, label = app.label, urlIcon = app.urlIcon;
    return {
      id: key,
      dataDpAnalyticsId: (0, import_GlobalAppSwitcher2.analyticsIdGenerator)(key),
      children: /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledAppList, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledIcon, {
        src: urlIcon,
        alt: "".concat(label, " - icon"),
        color,
        "aria-hidden": true
      }), /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledAppTitle, null, label))
    };
  });
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledContainer, {
    withKebabMenu
  }, /* @__PURE__ */ import_react.default.createElement(import_molecules.DropdownContent, {
    activator,
    className,
    disableListSelection: true,
    list: items,
    listOpenHandler: isAppsOpened,
    toggleItem: onSelectApp,
    width: "280px",
    ariaLabel: t("dp_core_globalAppSwitcher_greatMindsAppSwitcher"),
    dropdownItemAriaRole: "link",
    listMode: true,
    closeList: globalHeaderPopupStateConsumer && !appSwitcherModalState,
    customPositionOfPopover,
    tabTrapFocus: true
  })), withKebabMenu && is400percent && /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledAppSelectorIconContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledButton, {
    icon: "apps",
    "aria-label": t("dp_core_globalAppSwitcher_greatMindsAppSwitcher"),
    iconSize: 24,
    id: "app-switcher-mobile",
    onClick: function onClick() {
      return setAppSwitcherMobileState(true);
    },
    variant: "empty",
    width: "100%",
    ref: appSwitcherMobileButtonRef,
    "data-testid": "mobile-app-switcher"
  }, t("dp_core_globalAppSwitcher_greatMindsAppSwitcher")), appSwitcherMobileState && /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledAppSwitcherListContainer, {
    "data-testid": "appSwitcherMobileContainer",
    tabIndex: 0,
    ref: appSwitcherMobileRef
  }, /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledAppSelectorGoBackContainer, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalAppSwitcher.StyledButton, {
    icon: "arrow-back",
    "aria-label": t("dp_core_globalAppSwitcher_goBackButton_aria"),
    iconSize: 24,
    id: "app-switcher-back-mobile",
    onClick: function onClick() {
      return setAppSwitcherMobileState(false);
    },
    variant: "empty",
    width: "100%",
    "data-testid": "appSwitcherBackButton",
    ref: appSwitcherMobileGoBackButtonRef,
    onKeyPress: function onKeyPress(event) {
      return handleOnEnterPress(event);
    }
  }, t("dp_core_globalAppSwitcher_greatMindsAppSwitcher"))), items.map(function(app) {
    return /* @__PURE__ */ import_react.default.createElement(import_atoms.DropdownItem, {
      dataDpAnalyticsId: app.dataDpAnalyticsId,
      key: app.id,
      id: app.id,
      handleOnSelect: onSelectApp,
      disableListSelection: true,
      role: "link"
    }, app.children);
  }))));
};
var GlobalAppSwitcher_component_default = GlobalAppSwitcher;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalAppSwitcher
});
//# sourceMappingURL=GlobalAppSwitcher.component.js.map